import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { customerApi, setCustomerToken } from '../../services/customerAuth'
import { useLanguage } from '../../context/LanguageContext'

export default function CustomerLogin() {
  const { t } = useLanguage()
  const [form, setForm] = useState({ email: '', password: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  async function submit(e) {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      const { data } = await customerApi.post('/customer/login', form)
      setCustomerToken(data.token)
      navigate('/customer/dashboard')
    } catch (err) {
      if (err.response?.data?.code === 'EMAIL_NOT_VERIFIED') {
        setError(t('sp_email_not_verified', 'Please verify your email before logging in. Check your inbox for the verification link.'))
      } else {
        setError(err.response?.data?.message || t('sp_login_failed', 'Login failed'))
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '60px 16px', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 400, margin: '0 auto', background: '#fff', padding: 28, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <h2 style={{ color: '#153230', margin: '0 0 18px' }}>{t('sp_log_in', 'Log in')}</h2>
        <form onSubmit={submit}>
          <label style={{ display: 'block', margin: '10px 0' }}>
            <div style={labelStyle}>{t('email', 'Email')}</div>
            <input type="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={inputStyle} />
          </label>
          <label style={{ display: 'block', margin: '10px 0' }}>
            <div style={labelStyle}>{t('password', 'Password')}</div>
            <input type="password" required value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} style={inputStyle} />
          </label>
          {error && <div style={{ padding: 10, background: '#fee2e2', color: '#991b1b', borderRadius: 6, fontSize: 13, marginTop: 10 }}>{error}</div>}
          <button type="submit" disabled={loading} style={btnPrimary}>
            {loading ? t('sp_logging_in', 'Logging in…') : t('sp_log_in', 'Log in')}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#64748b' }}>
          {t('sp_new_here', 'New here?')} <Link to="/customer/signup" style={{ color: '#00d19f', fontWeight: 600 }}>{t('sp_create_an_account', 'Create an account')}</Link>
        </div>
        <div style={{ textAlign: 'center', marginTop: 8, fontSize: 12, color: '#94a3b8' }}>
          {t('sp_lost_access', 'Lost access? Contact support.')}
        </div>
      </div>
    </div>
  )
}

const labelStyle = { fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 }
const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit' }
const btnPrimary = { width: '100%', padding: '12px', background: '#00d19f', color: '#153230', border: 'none', borderRadius: 6, fontWeight: 700, fontSize: 15, cursor: 'pointer', marginTop: 10 }
